export const useHotjar = sharedComposable(() => {
  const {
    public: {
      scripts: {
        hotjar: { id: hotjarId },
      },
    },
  } = useRuntimeConfig()
  const { analyticalCookieConsentScriptTrigger, analyticalCookiesAccepted } = useCookieConsent()

  return useScriptHotjar({
    id: hotjarId,
    scriptOptions: {
      trigger: analyticalCookieConsentScriptTrigger,
      warmupStrategy: analyticalCookiesAccepted.value ? 'preload' : false,
    },
    scriptInput: {
      async: true,
    },
  })
})
